module.exports = __webpack_public_path__ + "static/img/learning-level2.5ceb1517.png";